import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/errors/background-403-left-bottom.svg")